import Cookie from "js.cookie";

function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

const initialState = {
    cookie_warning: getCookie('cookie-warning')
};

export default function cookieWarning(state=initialState, action) {
    switch (action.type) {
        case 'CLOSE_WARNING': {
            Cookie.set("cookie-warning", action.payload.cookie_warning);
            return { cookie_warning: action.payload.cookie_warning };
        }
        default: return state;
    }
}


// WEBPACK FOOTER //
// frontend/src/reducers/cookieWarning.js